import Leaflet, { LatLng } from 'leaflet';
import { LatLong } from 'record-it-utils/location/LocationUtils/LocationUtils';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { BasemapMapGlobalSettings } from '../BasemapMapGlobalSettings';
import { basemapGreyLayer } from './layer/basemapGreyLayer';
import { basemapNormalLayer } from './layer/basemapNormalLayer';
import { basemapOrthoLayer } from './layer/basemapOrthoLayer';
import { basemapOverlayLayer } from './layer/basemapOverlayLayer';
export class MapController {
  private map: Leaflet.Map | null = null;
  private handle: MapHandle | null = null;
  private controls: Array<Leaflet.Control> = [];
  constructor(private readonly options: MapControllerOptions) {}
  public init(): void {
    this.map = new Leaflet.Map(this.options.element, {
      zoom: 10,
      center: {
        lat: 47.0707657073521,
        lng: 15.433961109270003
      },
      layers: [basemapNormalLayer]
    });
    const handle = this.handle = new MapHandle(this.map);
    this.map.on('move', () => {
      this.options.onMapMove(handle);
    });
    this.addLayerControl();
  }
  public destroy(): void {
    for (const control of this.controls) {
      control.remove();
    }
    this.map?.remove();
  }
  public getHandle(): MapHandle {
    assertNotNullOrUndefined(this.handle, 'no handle available, is the MapController initialized?');
    return this.handle;
  }
  private addLayerControl(): void {
    const baseLayers = {
      Normal: basemapNormalLayer,
      Grau: basemapGreyLayer,
      Orthofoto: basemapOrthoLayer
    };
    const overlays = {
      'Beschriftungs-Overlay': basemapOverlayLayer
    };
    this.controls.push(Leaflet.control.layers(baseLayers, overlays).addTo(this.getMap()));
  }
  private getMap(): Leaflet.Map {
    assertNotNullOrUndefined(this.map, 'no map available, is the MapController not initialized?');
    return this.map;
  }
}
export class MapHandle {
  constructor(private readonly map: Leaflet.Map) {}
  public getCenter(): LatLong {
    return this.convertLeafletLatLngToLatLong(this.map.getCenter());
  }
  public setCenter(latLong: LatLong, options?: SetCenterOptions): void {
    this.map.setView(this.convertLatLongToLeafletLatLng(latLong), options?.zoom, {
      animate: options?.animate !== false && BasemapMapGlobalSettings.getEnableAnimations()
    });
  }
  private convertLeafletLatLngToLatLong(data: Leaflet.LatLng): LatLong {
    return {
      latitude: data.lat,
      longitude: data.lng
    };
  }
  private convertLatLongToLeafletLatLng(data: LatLong): Leaflet.LatLng {
    return new LatLng(data.latitude, data.longitude);
  }
}
export type MapControllerOptions = {
  element: HTMLElement;
  onMapMove: (handle: MapHandle) => void;
};
export type SetCenterOptions = {
  zoom?: number;
  /** default: true */
  animate?: boolean;
};